import { isPlatformServer } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Request } from 'express';
import { lastValueFrom } from 'rxjs';
import { BaseApiService } from '../_base-http/base-api.service';
import { StateService } from '../_services/state.service';

export let tokenServer = '';

@Injectable({
  providedIn: 'root',
})
export class ApiAuthorizeService extends BaseApiService {
  helper = new JwtHelperService();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handler: any;
  isServer = false;

  constructor(
    private _http: HttpClient,
    private _stateService: StateService,
    @Optional() @Inject(REQUEST) private request: Request,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {
    super(_http, _stateService);
    this.isServer = isPlatformServer(platformId);
    this._stateService.isServer$.next(this.isServer);
    this._stateService.isServer$.subscribe({
      next: (isServer: boolean) => {
        this.isServer = isServer;
      },
    });
  }

  private async getTokenServer(): Promise<string> {
    const token$ = this.http.get(this.baseApiUrl + 'Public/GetAccessTokenPublic', { responseType: 'text' });
    const token = await lastValueFrom(token$);
    tokenServer = token;
    if (this.request && this.request.body.redisCache) {
      if (!this.request.body.redisCache.isOpen) {
        await this.request.body.redisCache.connect();
      }
      await this.request.body.redisCache.set('api_token', token);
      await this.request.body.redisCache.expire('api_token', 3000);
    }
    if (!this.request) {
      this.handler = setTimeout(() => this.requestToken(), 60000);
    }
    return token;
  }

  private async getTokenLocal(): Promise<string> {
    let token = localStorage.getItem('initializerToken') || '';
    const hasTokenValid = this.isValidToken(token);
    try {
      if (!hasTokenValid) {
        const token$ = this.http.get(this.baseApiUrl + 'Public/GetAccessTokenPublic', { responseType: 'text' });
        token = await lastValueFrom(token$);
      }
      localStorage.setItem('initializerToken', token);
      this._stateService.token$.next(token);
    } catch {
      // Todo
    }
    return token;
  }

  async requestToken() {
    let token = ``;

    // Check redis cache
    if (this.request && this.request.body.redisCache) {
      if (!this.request.body.redisCache.isOpen) {
        await this.request.body.redisCache.connect();
      }
      token = await this.request.body.redisCache.get('api_token');
    }

    const cToken = token;
    tokenServer = token;

    if (cToken && !this.helper.isTokenExpired(cToken)) {
      return cToken;
    }

    if (this.isServer) {
      token = await this.getTokenServer();
    } else {
      token = await this.getTokenLocal();
    }
    return token;
  }

  private isValidToken(token: string): boolean {
    if (!token) {
      return false;
    }

    let tokenInfo = null;
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      tokenInfo = this.parseJwt<any>(token);
    } catch (Error) {
      return false;
    }

    if (!tokenInfo) {
      return false;
    }

    const d = new Date(0);
    return new Date().getTime() < d.setUTCSeconds(tokenInfo.exp);
  }

  private parseJwt<T>(token: string): T {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );

    return JSON.parse(jsonPayload);
  }
}
